<template>
  <div class="risk-statistics">
    <div class="stat-card">
      <span class="stat-icon sign-icon"><i :class="icons.signUserNum"></i></span>
      <span class="stat-label">签约人数</span>
      <strong class="stat-value">{{ data.signUserNum || '暂无' }}</strong><span class="stat-unit">人</span>
    </div>
    <div class="stat-card warning">
      <span class="stat-icon warning-icon"><i :class="icons.alarmUserNum"></i></span>
      <span class="stat-label">预警人数</span>
      <strong class="stat-value">{{ data.alarmUserNum || '暂无' }}</strong><span class="stat-unit">人</span>
    </div>
    <div class="stat-card">
      <span class="stat-icon bind-icon"><i :class="icons.alarmBindAccountNum"></i></span>
      <span class="stat-label">预警人员绑定用户总数</span>
      <strong class="stat-value">{{ data.alarmBindAccountNum || '暂无' }}</strong><span class="stat-unit">个</span>
    </div>
    <div class="stat-card success">
      <span class="stat-icon cash-icon"><i :class="icons.alarmUserCashAmount"></i></span>
      <span class="stat-label">预警人员累计成功提现</span>
      <strong class="stat-value">{{ data.alarmUserCashAmount || '暂无' }}</strong>
    </div>
    <div class="stat-card danger">
      <span class="stat-icon block-icon"><i :class="icons.riskBlockText"></i></span>
      <span class="stat-label">风控拦截笔数及金额</span>
      <strong class="stat-value">{{ data.riskBlockText || '暂无' }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RiskStatistics',
  data() {
    return {
      icons: {
        signUserNum: 'el-icon-s-custom',
        alarmUserNum: 'el-icon-warning-outline',
        alarmBindAccountNum: 'el-icon-s-claim',
        alarmUserCashAmount: 'el-icon-wallet',
        riskBlockText: 'el-icon-lock',
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="less" scoped>
.risk-statistics {
  display: grid;
  grid-template-columns: repeat(5, minmax(160px, 1fr));
  gap: 14px;
  margin: 10px 10px 14px;
}

.stat-card {
  position: relative;
  min-height: 76px;
  padding: 14px 88px 14px 18px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 5px rgba(31, 45, 61, .12);
}

.stat-icon {
  position: absolute;
  top: 50%;
  right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  transform: translateY(-50%);
}

.stat-icon i {
  display: block;
  width: 36px;
  height: 36px;
  font-size: 36px !important;
  line-height: 36px !important;
  text-align: center;
}

.sign-icon {
  color: #337dff;
  background: #edf4ff;
}

.warning-icon,
.block-icon {
  color: #f05252;
  background: #fff0f0;
}

.bind-icon {
  color: #f59e0b;
  background: #fff8e8;
}

.cash-icon {
  color: #08a176;
  background: #e9fbf4;
}

.stat-label,
.stat-value,
.stat-unit {
  display: block;
}

.stat-label {
  margin-bottom: 8px;
  color: #8792a2;
  font-size: 13px;
}

.stat-value {
  display: inline-block;
  color: #243247;
  font-size: 22px;
  line-height: 24px;
}

.stat-unit {
  display: inline-block;
  margin-left: 5px;
  color: #a1aaba;
  font-size: 12px;
}

.warning .stat-value {
  color: #d93030;
}

.success .stat-value {
  color: #08a176;
}

.danger .stat-value {
  color: #e31d48;
  font-size: 18px;
}

@media (max-width: 1200px) {
  .risk-statistics {
    grid-template-columns: repeat(3, minmax(160px, 1fr));
  }
}
</style>
